import { Route } from '@angular/router';

export const CAMERA_DOCS_ROUTE: Route = {
  path: 'camera-docs',
  loadChildren: () => import('./camera-docs.module').then(m => m.CameraDocsModule)
};
